import {Injectable} from '@angular/core';
import Broadcaster from "./broadcaster.service";
import EVENTS from "../enums/events.enum";


@Injectable()
class MenuTogglerService {
    public app;
    public appContainer;
    public menu;
    public topMenu;
    public mainContentContainer;
    public isToggled: boolean = false;
    private togglers = {
        leftMenu: false,
        topMenu: false
    }

    constructor(private broadcaster: Broadcaster) {

    }

    public toggleLeftMenu() {
        this.app.toggleClass('m-toggle');
        this.appContainer.toggleClass('m-toggle');
        this.menu.toggleClass('m-toggle');
        this.topMenu.toggleClass('m-toggle');
        this.togglers.leftMenu = !this.togglers.leftMenu;
        this.broadcaster.emit({
            event: EVENTS.MAP_RESIZE
        })
    }

    public toggleTopMenu() {
        this.mainContentContainer.toggleClass('m-toggle');
        this.topMenu.toggleClass('m-expanded');
        this.togglers.topMenu = !this.togglers.topMenu;
        this.broadcaster.emit({
            event: EVENTS.MAP_RESIZE
        })
    }

    /**
     * Preserves toggleLeftMenu. In case toggled class was added it will add it again.
     */
    public preserveToggle() {
        if (this.togglers.leftMenu) {
            this.app.addClass('m-toggle');
            this.appContainer.addClass('m-toggle');
            this.menu.addClass('m-toggle');
            this.topMenu.addClass('m-toggle');
        } else {
            this.app.removeClass('m-toggle');
            this.appContainer.removeClass('m-toggle');
            this.menu.removeClass('m-toggle');
            this.topMenu.removeClass('m-toggle');
        }
        if (this.togglers.topMenu) {
            this.mainContentContainer.addClass('m-toggle');
            this.topMenu.addClass('m-expanded');
        } else {
            if (this.mainContentContainer)
                this.mainContentContainer.removeClass('m-toggle');
            this.topMenu.removeClass('m-expanded');
        }
    }

}

export default MenuTogglerService;


// WEBPACK FOOTER //
// ./src/app/services/menuToggler.service.ts